import { AssignPluginParameterVisitor } from "../parser/visitor/AssignPluginParameterVisitor";
import { DefaultWalker } from "../parser/visitor/DefaultWalker";
import { NAME as ParserTaskName } from "@jetjs/parser-task";
import { DATA_ATTR_NAMESPACE } from "../namespace";
import { PluginReader } from "./PluginReader";
/**
 * Plugin Parser searches the DOm for plugin definitions and uses the generated Parser to create the AST.
 * After Parsing is done, the parameters are extracted from the DOM and assinged to the AST.
 *
 * @public
 */
export class PluginParser {
    /**
     *
     * @param threadpool - the threadpool is used to do the plugin definition parsing
     */
    constructor(threadpool, namespace = DATA_ATTR_NAMESPACE, batchSize = 5) {
        this.threadpool = threadpool;
        this.ns = namespace.trim();
        this.batchSize = batchSize;
        this.astWalker = new DefaultWalker();
        this.reader = new PluginReader(this.ns);
    }
    findAll(element) {
        return this.reader.findAll(element);
    }
    /**
     *
     * @param nodes - array of HTMLElements to parse
     *              (use [].slice.call(document.querySelectorAll<HTMLElement>(".selector")) to convert a NodeList to an array of HTMLElements)
     * @param callback - function to call with parsed PluginDefinitions
     */
    parse(nodes, callback, errorCallback) {
        let batchSize = this.batchSize;
        while (nodes.length > 0) {
            // nodes to parse in this step
            const batchNodes = nodes.splice(0, batchSize);
            this.threadpool
                .submit({
                name: PluginParser.PARSE_JOB_NAME,
                parameter: this.getParseParameter(batchNodes)
            })
                .then((result) => {
                const defs = result.defs;
                defs.forEach((def) => {
                    const node = batchNodes.shift();
                    if (!node) {
                        throw new Error("Unexpected end of nodes");
                    }
                    try {
                        callback(
                        // response array has the same order as our batchNodes array, where the parse input was read from
                        node, 
                        // add plugin parameter before passing it to the callback
                        this.addPluginParameter(node, def));
                    }
                    catch (err) {
                        if (errorCallback) {
                            errorCallback(err, [node]);
                        }
                    }
                });
            })
                .catch(err => {
                if (errorCallback) {
                    errorCallback(err, batchNodes);
                }
            });
            // let the batch size grow to get the best performance.
            batchSize = batchSize * this.batchSize;
        }
    }
    addPluginParameter(node, def) {
        // walk through the AST and assign the parameter for each plugin
        this.astWalker.walk(def, new AssignPluginParameterVisitor(node, this.ns));
        return def;
    }
    getParseParameter(nodes) {
        return {
            defs: nodes.map(n => this.reader.readDefinition(n))
        };
    }
}
PluginParser.PARSE_JOB_NAME = ParserTaskName;
//# sourceMappingURL=PluginParser.js.map